import React from 'react';
import './components/Main.css';

import MainComp from './components/Main';


const App = () => {
  return (
    <>
      <MainComp />
    </>
  );
}

export default App;
